import { subDays, format } from 'date-fns';

export const daily = Array.from({ length: 7 }, (_, i) => ({
  day: format(subDays(new Date(), 6 - i), 'eee'),
  amount: 0,
  amountFormatted: '0.00',
  barChartPoint: 0
}));

daily[0].amount = 1500000;
daily[1].amount = 980000;
daily[2].amount = 0;
daily[3].amount = 1080000;
daily[4].amount = 880000;
daily[5].amount = 1300000;
daily[6].amount = 600000;

// Utility to calculate average
function average(arr) {
  const total = arr.reduce((sum, d) => sum + d.amount, 0);
  return total / arr.length;
}

// Mock previous week by slightly altering the daily data
const prevWeek = daily.map(d => ({
  ...d,
  amount: Math.floor(d.amount * (0.8 + Math.random() * 0.4)) 
}));

// Mock last 30 days
const last30Days = Array.from({ length: 30 }, () => ({
  amount: Math.floor(Math.random() * 2000000)
}));

// Mock previous month
const prevMonth = Array.from({ length: 30 }, () => ({
  amount: Math.floor(Math.random() * 2000000)
}));

const mockDenominations = [
  { value: 1, type: 0, index: 0, weight: 1 },
  { value: 5, type: 0, index: 1, weight: 1 },
  { value: 10, type: 1, index: 2, weight: 1 }
];

export const donutTabData = {
  last7: {
    label: 'Daily Avg (Last 7 days)',
    value: average(daily),
    maxValue: Math.max(...daily.map(d => d.amount)),
    currency: {
      EURExchangeRate: 1,
      USDExchangeRate: 1,
      cid: 1,
      currencyStr: 'EUR',
      denominations: mockDenominations,
      description: 'Euro',
      factor: 1,
      mc_value: [1, 5, 10],
      mc_valueType: [0, 0, 0],
      mc_valueWeight: [1, 1, 1],
      nBills: 3,
      nCoins: 3
    },
    maxSuffix: ''
  },
  prevWeek: {
    label: 'Daily Avg (Prev. week)',
    value: average(prevWeek),
    maxValue: Math.max(...prevWeek.map(d => d.amount)),
    currency: {
      EURExchangeRate: 1,
      USDExchangeRate: 1,
      cid: 1,
      currencyStr: 'EUR',
      denominations: mockDenominations,
      description: 'Euro',
      factor: 1,
      mc_value: [1, 5, 10],
      mc_valueType: [0, 0, 0],
      mc_valueWeight: [1, 1, 1],
      nBills: 3,
      nCoins: 3
    },
    maxSuffix: ''
  },
  last30: {
    label: 'Daily Avg (Last 30 days)',
    value: average(last30Days),
    maxValue: Math.max(...last30Days.map(d => d.amount)),
    currency: {
      EURExchangeRate: 1,
      USDExchangeRate: 1,
      cid: 1,
      currencyStr: 'EUR',
      denominations: mockDenominations,
      description: 'Euro',
      factor: 1,
      mc_value: [1, 5, 10],
      mc_valueType: [0, 0, 0],
      mc_valueWeight: [1, 1, 1],
      nBills: 3,
      nCoins: 3
    },
    maxSuffix: ''
  },
  prevMonth: {
    label: 'Daily Avg (Prev. month)',
    value: average(prevMonth),
    maxValue: Math.max(...prevMonth.map(d => d.amount)),
    currency: {
      EURExchangeRate: 1,
      USDExchangeRate: 1,
      cid: 1,
      currencyStr: 'EUR',
      denominations: mockDenominations,
      description: 'Euro',
      factor: 1,
      mc_value: [1, 5, 10],
      mc_valueType: [0, 0, 0],
      mc_valueWeight: [1, 1, 1],
      nBills: 3,
      nCoins: 3
    },
    maxSuffix: ''
  }
};
